import { ComponentPropsWithRef } from "react";
import LabelStyle from "./css/Label.module.css";
import clsx from "clsx";

type LabelProps = ComponentPropsWithRef<"label"> & {
    required?: boolean;
};

function Label({
    children,
    required = false,
    ...props
}: LabelProps) {
    return (
        <label
            className={clsx(
                LabelStyle['label'],
            )}
            {...props}
        >
            {children}{required && <em>*</em>}
        </label>
    )
}

export default Label;